import { ApplicationRef, ComponentFactoryResolver, ComponentRef, EmbeddedViewRef, Inject, Injectable, Injector } from "@angular/core";
import { Router } from "@angular/router";
import { PaymentControllerService } from "@aparraga/ahoracrypto-api-sdk/sdk";
import { Observable, of, ReplaySubject } from 'rxjs';
import { Order } from "@aparraga/ahoracrypto-client-common/src/app/common/domain/order";
import { PaymentGateway } from "@aparraga/ahoracrypto-client-common/src/app/common/payment/gateway";
import { StripeCardPopupComponent } from "@aparraga/ahoracrypto-client-common/src/app/common/payment/gateways/stripecardpopup/stripecardpopup.component";
import { ENVIRONMENT } from "../../utils/injectiontokens";

@Injectable({
  providedIn: 'root'
})
export class StripeCardGateway implements PaymentGateway {

  public gatewayId: string = 'stripe-card';

  protected clientSecret: string;

  protected componentRef: ComponentRef<StripeCardPopupComponent> = null;

  public constructor(protected paymentControllerService: PaymentControllerService,
                     protected componentFactoryResolver: ComponentFactoryResolver,
                     protected injector: Injector,
                     @Inject(ENVIRONMENT) protected environment: any,
                     protected appRef: ApplicationRef,
                     protected router: Router) {

  }

  public setupPayment(order: Order, paymentData: any): Observable<any> {

    let returnValue: ReplaySubject<any> = new ReplaySubject();
    this.paymentControllerService.paymentControllerSetupPayment(this.gatewayId, {order: order, data: paymentData}).subscribe(paymentResult => {
      if(paymentResult != null) {
        let clientSecret = paymentResult[0];
        if(clientSecret != 'ERROR') {
          this.clientSecret = clientSecret;
          returnValue.next(clientSecret);
        }
        else {
          returnValue.next('ERROR');
        }
      }
      else {
        returnValue.next("ERROR");
      }
    });
    return returnValue;

  }

  public initPayment(order: Order, paymentData: any) {
    let returnValue: ReplaySubject<any> = new ReplaySubject();

    this.showPopup().then(stripeResult => {
        // Send the stripe result to your backend
        this.paymentControllerService.paymentControllerInitPayment(
            this.gatewayId, 
            { 
                order: order, 
                data: {
                    ...paymentData,
                    paymentIntentId: stripeResult.paymentIntentId,
                    paymentMethodId: stripeResult.paymentMethodId
                } 
            }
        ).subscribe(paymentResult => {
            if (paymentResult != null) {
                let paymentId = paymentResult[0];
                if (paymentId != 'ERROR') {
                    returnValue.next({ status: 'SUCCEEDED', paymentId: paymentId });
                } else {
                    returnValue.next('ERROR');
                }
            } else {
                returnValue.next("ERROR");
            }
        });
    },
    (error) => {
        returnValue.next("ERROR");
    });

    return returnValue;
  }

  public completePayment(params): Observable<any> {

    let returnValue: ReplaySubject<any> = new ReplaySubject();

    this.paymentControllerService.paymentControllerCompletePayment(this.gatewayId, params).subscribe(paymentResult => {
      if (paymentResult != null) {
        returnValue.next(paymentResult);
      }
    });

    return returnValue;

  }

  showPopup() {
    if(this.componentRef == null) {
      // 1. Create factory for dynamic component
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(StripeCardPopupComponent);

      // 2. Create component without container
      this.componentRef = componentFactory.create(this.injector);

      // 3. Attach component view to application to process lifecycle
      this.appRef.attachView(this.componentRef.hostView);

      // 4. Extract DOM element from component
      const domElem = (this.componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;

      // 5. Insert element into DOM. For example, we add it to the body:
      document.body.appendChild(domElem);

      this.componentRef.instance.stripePublicKey = this.environment.stripePublishableKey;
    }

    return this.componentRef.instance.processPayment(this.clientSecret);

  }

}
